import { Injectable } from '@angular/core';
import {DaoGeneric} from "@Services/base/daoService";
import {Bel, BelState} from "./bel.model";
import {environment} from "@Env/environment";
import {HttpClient} from "@angular/common/http";
import {HelperDeposit} from "../../../helper/helperDeposit";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";


@Injectable({
  providedIn: 'root'
})
export class BelService extends DaoGeneric<Bel> {
  private url = `${environment.baseUrl}/api_archive/elimination/`;
  readonly state: string[] = [];

  constructor(private httpClient: HttpClient) {
    super(httpClient);
    this.state[BelState.CONSTITUTION_REVISION] = 'Constitution/Révision';
    this.state[BelState.SENDTOAD] = 'Envoi AD';
    this.state[BelState.SENDTOSERVICES] = 'Envoi pour signature aux services';
    this.state[BelState.GOFORDESTRUCTION] = 'Bon pour la destruction';
    this.state[BelState.DESTROYED] = 'Détruit';
  }

  getRootUrl(): string {
    return this.url;
  }

  displayStateNames(enumState: number) {
    return this.state[enumState];
  }

  displayState(bel: Bel): string {
    return this.state[bel?.state ?? BelState.CONSTITUTION_REVISION];
  }

  getChipButton(bel: Bel): string {
    return this.getChipButtonByState(bel.state);
  }

  getChipButtonByState(state: BelState) {
    const stateLabel = this.displayStateNames(state);
    const classType = HelperDeposit.getClassColorBtnChip(state);
    return `<small><span class="state-archivage-chip ${classType}">${stateLabel}</span></small>`;
  }

  getStates(): string[]{
    return this.state;
  }

  getEntitesInstructionsInforamtionsComplementaires(bel: Bel): Observable<any> {
    const url = `${this.url}${bel.id}/entites_instructions_infoscomps`;
    return this.httpClient.get<any>(url);
  }

  public exportBelPdf(bel: Bel) {
    const url = `${this.url}${bel.id}/export_bel_pdf/`;
    return this.httpClient.get(url, {
      responseType: 'blob'
    }).pipe(map((data: any) => new Blob([data])));
  }
}
